import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { Logger, LogManager } from '../../utils/logger/logger';
import { Strings } from '../../utils/resources/strings';
import { ListTonesRequest } from '../api/mytunes/listtones/listtonesrequest';
import { ListTonesResponse, ListTonesResponseDtoImpl } from '../api/mytunes/listtones/listtonesresponse';
import { ChildListTonesDto } from '../dto/listtones/childlisttonesdto';
import { CurrentlyPlayingListTonesBuilder } from '../dto/listtones/currentlyplayingtunes/currentlyplayinglisttonesbuilder';
import { CurrentlyPlayingToMyListDetails } from '../dto/listtones/currentlyplayingtunes/currentlyplayingtomylistdetails';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { ListTonesAPIProcessorImpl } from './listtonesapiprocessor';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';

export class ListTonesForCurrentlyPlayingTunesAPIProcessorImpl extends SixdeeCRBTAPIProcessor<ListTonesRequest, ListTonesResponse>
{
    private LOGGER: Logger = LogManager.getLogger(ListTonesAPIProcessorImpl.name);
    execute(request: ListTonesRequest): void {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        this.LOGGER.log("onSuccess() invoked");
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

               let response = new ListTonesResponseDtoImpl(APIFeatures.LIST_TONES, "List Tones Success");
               let ChildListTonesDtos: ChildListTonesDto[] = new CurrentlyPlayingListTonesBuilder(responseMapper.getResponseMap(), this.getContext()).buildAll();

               response.setListTonesResponseDtos(new CurrentlyPlayingToMyListDetails().parseListTonesResponse(ChildListTonesDtos, this.getContext()));

                this.getAPISuccess(response);
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new ListTonesResponseDtoImpl(APIFeatures.LIST_TONES, this.getContext().getResources().getString(Strings.no_data_list_available)));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new ListTonesResponseDtoImpl(APIFeatures.LIST_TONES, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch (e) {
            this.getAPIFailure(new ListTonesResponseDtoImpl(APIFeatures.LIST_TONES, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        super.onFailure(responseMapper);

            this.getAPIFailure(new ListTonesResponseDtoImpl(APIFeatures.LIST_TONES, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/listtonesforcurrentlyplayingapiprocessor.tsx